module.exports = __webpack_public_path__ + "img/fan_product-desc2.ba8ea93c.png";